module.exports = __webpack_public_path__ + "static/img/1739_phase_function_Paper_PointsHejduk_Prediction.cef39a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1739_phase_function_Paper_PointsHejduk_Prediction.png
// module id = mp/c
// module chunks = 0